import { FC, useState, useMemo, useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { Row, Col, Tag, HorizontalScroll } from '@/client/components'
import { useWindowSize } from '@/client/hooks'
import { generateTypes } from './generateTypes'
import * as S from './styles'
import { GalleryProps } from '../types'
import MasonryGrid from '@/client/components/MasonryGrid'

export const Gallery: FC<GalleryProps> = ({ gallery, filter_text_for_all_photos }) => {
  const { locale } = useRouter()
  const { breakpoint } = useWindowSize()
  const [selectedType, setSelectedType] = useState<string>(filter_text_for_all_photos)
  const typeList = generateTypes({ filter_text_for_all_photos, gallery })

  useEffect(() => {
    setSelectedType(filter_text_for_all_photos)
  }, [locale, filter_text_for_all_photos])

  const filter = useMemo(
    () =>
      typeList.map((type) => (
        <Tag
          key={type}
          size='large'
          kind='filter'
          action={() => setSelectedType(type)}
          isActive={type === selectedType}
        >
          {type}
        </Tag>
      )),
    [typeList, selectedType]
  )

  const filteredList = useMemo(() => {
    if (selectedType === filter_text_for_all_photos) {
      return gallery
    }

    return gallery.filter(({ type }) => type.some((t) => t.item === selectedType))
  }, [gallery, selectedType, filter_text_for_all_photos])

  const cached = useRef(new Set<string>())

  return (
    <>
      <Row>
        <Col xs={12}>
          <S.Filter>
            {breakpoint !== 'wide-desktop' && breakpoint !== 'desktop' && (
              <HorizontalScroll className='gallery-scroll'>{filter}</HorizontalScroll>
            )}
            {(breakpoint === 'wide-desktop' || breakpoint === 'desktop') && <div>{filter}</div>}
          </S.Filter>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <MasonryGrid images={filteredList} selectedType={selectedType} />
        </Col>
      </Row>
    </>
  )
}
